import React, { Fragment } from "react";
import { connect } from 'react-redux';
import { Button, Modal, Form, Collapse } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faMotorcycle } from '@fortawesome/free-solid-svg-icons';
import Numeral from 'numeral';

import Cards from "../../../components/UI/Orden/tarjetas.jsx";
import ComponentToPrint from './imprimir/encabezadoImp.jsx';
import GoogleMapControl from '../../../components/UI/mapa/mapaGoogle';

const ConsultaRepartidoresInt = props => {

    const {
        //  Data Props
        listaOrdenes, mapa, infoboxes, center, filtro,
        viewAs, repartidorList, userWorkspace, modals, listaOrdenesFiltradas, collapsibles, loading,

        //  Methods
        handleClickEvent, assignOrder, toggleModal, infoRoutes, onChangeBuscar, toggleViewAs
    } = props;

    const iframePrintId = "repartidorTicket";
    let ordenes = {};

    //  Hay un filtro activo
    if (listaOrdenesFiltradas && filtro) {
        ordenes.current = listaOrdenesFiltradas;
    } else {
        ordenes.current = listaOrdenes;
    }

    //  Generate visual component per order item
    const Tarjetas = ({ lista, color, type }) => {
        return lista && lista.length > 0 ? lista.map(item => {

            return <div key={item.Id} className="col-12">
                <div className="row">
                    <Cards
                        col={12}
                        claseEstado={item.Color + (userWorkspace.selectedOrder && (item.Id === userWorkspace.selectedOrder.Id) ? " selected" : "")}
                        style={{}}
                        claseTipo={(item.Tipo_Entrega)}
                        claseApoyo={(item.Apoyo === 'NO' ? '' : (item.Apoyo === 'RA' ? "flaticon-inbox" : "flaticon-outbox"))}
                        item={item}
                        onClick={handleClickEvent}
                        type={type}
                    />
                </div>
            </div>
        }) : type !== "Ordenes En Ruta" && (repartidorList.filter((x) => x.Ordenes.length > 0).length === 0 && lista.length === 0 && loading) ?
            <div className="col-12">
                <Skeleton count={5} height={85} duration={2} />
            </div>
            : type === "Ordenes En Ruta" ?
                <div style={{ textAlign: "center" }} className="col-12">
                    <h5>Las órdenes que se asignen a este repartidor aparecerán aquí.</h5>
                </div>
                : <div style={{ textAlign: "center" }} className="col-12">
                    <h6>No hay datos para mostrar.</h6>
                </div>
    }

    const Repartidores = ({ lista, type }) => {

        if (!lista || lista.length === 0) {
            return "";
        }

        let types = ["Ordenes Asignadas", "Sin Ordenes Asignadas", "En Ruta", "No Disponible"];
        let courierList = lista.filter(courier => courier.Estatus === type && courier.Disponible);

        if (type === "No Disponible") {
            courierList = lista.filter(courier => !courier.Disponible);
        }

        return lista && lista.length > 0 ? courierList.map(item => {

            let rowStyle = { cursor: "pointer" }

            //  El repartidor ha sido seleccionado por el usuario
            if (userWorkspace.selectedCourier && userWorkspace.selectedCourier.Id === item.Id) {
                rowStyle.color = "#4C7EF8";
            }

            return <div key={item.Id} className="row">
                <div className="col-12">
                    <div
                        className="row mb-2"
                        style={rowStyle}
                        onClick={(event) => handleClickEvent(event, { handler: "selectCourier", data: Object.assign({}, item) })}
                    >
                        <div className={type === types[0] || type === types[2] ? "col-10" : "col-12"}>
                            <strong>{item.Id} - {item.Nombre}</strong>
                        </div>
                        {
                            type === types[0] || type === types[2] ?
                                <div className="col-2">
                                    <span><FontAwesomeIcon icon={faMotorcycle} /></span>
                                </div>
                                : ""
                        }
                    </div>
                </div>
            </div>
        }) : "";
    };

    let lat = 0;
    let lng = 0;
    let title = '';
    let icon = '';
    if (mapa && mapa.location) {
        lat = mapa.location.latitud;
        lng = mapa.location.longitud;
        title = mapa.option.title;
        icon = mapa.option.icon;
    }

    const mapaHtml = viewAs.Map && center && (center[0] !== 0 || center[1] !== 0) ?
        <div className="row">
            <div className="col-12 no-gutters p-0">
                <div style={{ height: '68vh' }} className="mapWithCustomInfobox">
                    <GoogleMapControl
                        center={{ lat, lng }}
                        zoom={15}
                        position={{ lat, lng }}
                        title={title}
                        label={title}
                        icon={icon}
                        wayPoints={mapa.wayPoints}
                    />
                </div>
            </div>
        </div>
        : null;

    return (
        <Fragment>
            <section className="monitor-suc">
                <div className="row no-gutters">
                    {/* =====   Órdenes Sin Asignar     =====*/}
                    <div className="col-3">
                        <div className="lista-ordenes customScrollbar" style={{ height: "80vh !important" }}>
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="mb-4">Órdenes Sin Asignar</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <input disabled={loading} className="form-control" type="search" placeholder="Buscar" value={filtro} onChange={onChangeBuscar} />
                                </div>
                            </div>
                            <div className="row justify-content-between mt-4">
                                <div className="col-6">
                                    <Button disabled={loading} style={{ fontSize: '0.7em' }} onClick={() => assignOrder("btnAssignSingleOrder")} variant="secondary">ASIGNAR ORDEN</Button>
                                </div>
                                <div className="col-6" style={{ textAlign: "right" }}>
                                    <Button disabled={loading} style={{ fontSize: '0.7em' }} onClick={() => assignOrder("btnAssignMultipleOrders")} variant="secondary">ASIGNAR TODAS</Button>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <Tarjetas lista={ordenes.current} color="azul" type="Ordenes Sin Asignar" />
                            </div>
                        </div>
                    </div>

                    {/* =====   Repartidores    =====*/}
                    <div className="col-3" style={{ borderRight: "1px solid #D5D6E2" }}>
                        <div className="articulos customScrollbar" style={{ height: "80vh !important" }}>
                            <div className="row">
                                <div className="col-12">
                                    <h5 className="mb-4">Repartidores</h5>
                                </div>
                            </div>
                            {
                                userWorkspace.selectedCourier && userWorkspace.selectedCourier.Estatus === "Ordenes Asignadas" ?
                                    <div className="row justify-content-end" style={{ textAlign: "right" }}>
                                        <div className="col-7">
                                            <Button disabled={loading}
                                                onClick={(event) => handleClickEvent(event, { handler: "setEnRoute" })}
                                                variant="primary">PASAR A RUTA</Button>
                                        </div>
                                    </div>
                                    : ""
                            }
                            <div className="row align-items-center">
                                <div className="col-10">
                                    <div className="grupo-repartidores-2"><br />Con Órdenes Asignadas</div>
                                </div>
                                <div className="col-2" style={{ marginTop: "25px" }}>
                                    <span>
                                        <FontAwesomeIcon
                                            onClick={(e) => handleClickEvent(e, { handler: "toggleCollapsible", data: { item: "repAsignados" } })}
                                            style={{ cursor: "pointer" }} icon={collapsibles.repAsignados.show ? faChevronDown : faChevronUp} />
                                    </span>
                                </div>
                            </div>
                            <Collapse in={collapsibles.repAsignados.show}>
                                <div id="repAsignados" className="col-12">
                                    {
                                        repartidorList.length > 0 || !loading ?
                                            <Repartidores lista={repartidorList} type="Ordenes Asignadas" />
                                            : <div className="row">
                                                <div className="col-12">
                                                    <Skeleton count={3} height={25} />
                                                </div>
                                            </div>
                                    }
                                </div>
                            </Collapse>

                            <div className="row align-items-center">
                                <div className="col-10">
                                    <div className="grupo-repartidores-2"><br />Sin Órdenes Asignadas</div>
                                </div>
                                <div className="col-2" style={{ marginTop: "25px" }}>
                                    <span>
                                        <FontAwesomeIcon onClick={(e) => handleClickEvent(e, { handler: "toggleCollapsible", data: { item: "repSinAsignar" } })}
                                            style={{ cursor: "pointer" }}
                                            icon={collapsibles.repSinAsignar.show ? faChevronDown : faChevronUp} />
                                    </span>
                                </div>
                            </div>
                            <Collapse in={collapsibles.repSinAsignar.show}>
                                <div id="repSinAsignar" className="col-12">
                                    {
                                        repartidorList.length > 0 || !loading ?
                                            <Repartidores lista={repartidorList} type="Sin Ordenes Asignadas" />
                                            : <div className="row">
                                                <div className="col-12">
                                                    <Skeleton count={3} height={25} />
                                                </div>
                                            </div>
                                    }
                                </div>
                            </Collapse>

                            <div className="row align-items-center">
                                <div className="col-10">
                                    <div className="grupo-repartidores-2"><br />En Ruta</div>
                                </div>
                                <div className="col-2" style={{ marginTop: "25px" }}>
                                    <span>
                                        <FontAwesomeIcon
                                            onClick={(e) => handleClickEvent(e, { handler: "toggleCollapsible", data: { item: "repEnRuta" } })}
                                            style={{ cursor: "pointer" }}
                                            icon={collapsibles.repEnRuta.show === true ? faChevronDown : faChevronUp} />
                                    </span>
                                </div>
                            </div>
                            <Collapse in={collapsibles.repEnRuta.show}>
                                <div id="repEnRuta" className="col-12">
                                    {
                                        repartidorList.length > 0 || !loading ?
                                            <Repartidores lista={repartidorList} type="En Ruta" />
                                            : <div className="row">
                                                <div className="col-12">
                                                    <Skeleton count={3} height={25} />
                                                </div>
                                            </div>
                                    }
                                </div>
                            </Collapse>

                            <div className="row align-items-center">
                                <div className="col-10">
                                    <div className="grupo-repartidores-2"><br />No Disponible</div>
                                </div>
                                <div className="col-2" style={{ marginTop: "25px" }}>
                                    <span>
                                        <FontAwesomeIcon onClick={(e) => handleClickEvent(e, { handler: "toggleCollapsible", data: { item: "repNoDisp" } })}
                                            style={{ cursor: "pointer" }}
                                            icon={collapsibles.repNoDisp.show === true ? faChevronDown : faChevronUp} />
                                    </span>
                                </div>
                            </div>
                            <Collapse in={collapsibles.repNoDisp.show}>
                                <div id="repNoDisp" className="col-12">
                                    {
                                        repartidorList.length > 0 || !loading ?
                                            <Repartidores lista={repartidorList} type="No Disponible" />
                                            : <div className="row">
                                                <div className="col-12">
                                                    <Skeleton count={3} height={25} />
                                                </div>
                                            </div>
                                    }
                                </div>
                            </Collapse>
                        </div>
                    </div>

                    {/* =====   Detalle de Orden    =====*/}
                    <div className="col-6">
                        <div className="orden-ubicacion customScrollbar" style={{ height: "80vh !important" }}>
                            {/* =====   User has selected a courier by click event  ===== */}
                            {
                                userWorkspace.selectedCourier ?
                                    <div style={{ height: '7vh' }} className="row justify-content-between">
                                        <div className="col-5" style={{ lineHeight: "7vh", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                            <h5>{userWorkspace.selectedCourier.Id + " - " + userWorkspace.selectedCourier.Nombre}</h5>
                                        </div>

                                        {
                                            userWorkspace.selectedCourier && userWorkspace.selectedCourier.Estatus === "En Ruta" ?
                                                <div className="col-4" style={{ lineHeight: "7vh" }}>
                                                    <Button disabled={loading}
                                                        onClick={(event) => handleClickEvent(event, { handler: "finishRoute" })}
                                                        variant="primary">ANULAR RUTA</Button>
                                                </div>
                                                : ""
                                        }

                                        <div className="col-3" style={{ textAlign: "right", lineHeight: "7vh" }}>
                                            <span style={{ color: "blue", cursor: "pointer" }}
                                                onClick={() => toggleViewAs(viewAs.Map ? "List" : "Map")} >
                                                {viewAs.Map ? "Lista de Órdenes" : "Ver Mapa"}
                                            </span>
                                        </div>
                                    </div>
                                    : <div style={{ height: '7vh', textAlign: "center" }} className="row">
                                        <div className="col-12">
                                            <h6>Seleccione un repartidor</h6>
                                        </div>
                                    </div>
                            }

                            {
                                viewAs.Map ?
                                    mapaHtml
                                    : userWorkspace.selectedCourier ?
                                        <div style={{ height: "70vh", overflowY: "scroll" }} className="row mt-4 align-items-center">
                                            <Tarjetas lista={userWorkspace.selectedCourier.Ordenes} color="" type="Ordenes En Ruta" />
                                        </div>
                                        : toggleViewAs("Map")
                            }
                        </div>
                    </div>
                </div>
            </section >
            <Modal show={modals.RouteModal.show} >
                <Modal.Header >
                    <Modal.Title>Pasar a Ruta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            ¿Desea pasar a {userWorkspace.selectedCourier ? userWorkspace.selectedCourier.Nombre : ""} a ruta?
                        </div>
                    </div>
                    <Form className="row justify-content-center mt-3 mb-3">
                        <div className="col-6">
                            <Form.Check
                                checked={modals.RouteModal.checks.chkCopiaCaja}
                                onClick={(e) => { handleClickEvent(e, { handler: "toggleRouteModalCheck", data: "chkCopiaCaja" }) }}
                                type="checkbox"
                                id="chkCopiaCaja"
                                label="Copia de Caja"
                            />
                        </div>
                        <div className="col-6">
                            <Form.Check
                                checked={modals.RouteModal.checks.chkImprimirDetalle}
                                onClick={(e) => { handleClickEvent(e, { handler: "toggleRouteModalCheck", data: "chkImprimirDetalle" }) }}
                                type="checkbox"
                                id="chkImprimirDetalle"
                                label="Imprimir Detalle"
                            />
                        </div>
                    </Form>
                    <div className="row justify-content-end">
                        <div className="col-6">
                            <Button className="mr-3" variant="secondary" onClick={() => toggleModal("RouteModal", false, "Cancelar")}>
                                Cancelar
                            </Button>
                            <Button
                                variant="primary"
                                onClick={
                                    (event) => {
                                        toggleModal("RouteModal", false, "Aplicar");
                                    }
                                }
                            >
                                Aplicar
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modals.ProductsModal.show} size="lg">
                <Modal.Header >
                    <Modal.Title>Detalle de Orden {modals.ProductsModal.order ? "#" + modals.ProductsModal.order.Id : ""}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row" >
                            <table className="col-12">
                                <tr>
                                    <td colSpan="2" style={{ fontWeight: 'bold' }}>Artículo</td>
                                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>Total</td>
                                </tr>
                                {
                                    modals.ProductsModal.products.map(product => {
                                        return <tr key={product.Articulo_Id}>
                                            <td><img height="100px" src={product.Imagen_Path} /></td>
                                            <td>
                                                {`${product.Articulo_Codigo_Principal ? product.Articulo_Codigo_Principal : product.Articulo_Id} - ${product.Articulo_Nombre}`}
                                                <br />
                                                <strong>Cantidad: {product.Detalle_Facturar}</strong>
                                            </td>
                                            <td style={{ textAlign: "right" }}>{Numeral(product.Total).format('0,0.00')}</td>
                                        </tr>
                                    })
                                }
                            </table>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-6" style={{ textAlign: "right" }}>
                                <Button className="mr-3" variant="secondary" onClick={() => toggleModal("ProductsModal", false, "Cancelar")}>
                                    Cerrar
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modals.PrintModal.show} >{/*size="lg">*/}
                <Modal.Header >
                    <Modal.Title>Imprimir</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="row align-items-center justify-content-center customScrollbar" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            <ComponentToPrint
                                printId={iframePrintId}
                                repartidor={userWorkspace.selectedCourier}
                                empresa={props.empresa}
                                callCenter={props.callCenter}
                                sucursal={props.sucursal}
                                artefactos={{
                                    copiaRepartidor: true,
                                    copiaCaja: modals.RouteModal.checks.chkCopiaCaja,
                                    imprimirDetalle: modals.RouteModal.checks.chkImprimirDetalle
                                }}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="mr-3" variant="secondary" onClick={() => toggleModal("PrintModal", false, "Cancelar")}>
                        Cancelar
                    </Button>
                    <div>
                        <button type="button" className="btn btn-primary" onClick={() => {
                            window.frames[iframePrintId].focus();
                            window.frames[iframePrintId].print();
                        }}>Imprimir</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </Fragment >
    );
}

const mapStateToProps = state => {
    return {
        empresa: state.parametros.empresa,
        callCenter: state.parametros.callCenter
    };
};

export default connect(mapStateToProps)(ConsultaRepartidoresInt);